<!--
 * @Autor: Baowang
 * @Date: 2024-11-18 17:22:31
 * @pageName: 主页面
 * @LastEditTime: 2024-11-20 10:12:14
-->
<template>
	<div id="app">
		<publicTopVue />
		<router-view></router-view>
		<publicBottomVue :bgColor="$store.state.bgColor" />
	</div>
</template>
<script>
import publicBottomVue from "./components/public/publicBottom.vue"; //底部按钮样式
import publicTopVue from "./components/public/publicTop.vue";
export default {
	components: { publicBottomVue, publicTopVue },
};
</script>
<style lang="less">
.fontStyle{
	 font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}

.flex {
	display: flex;
}


.flex-sub {
	flex: 1;
}

.flex-direction {
	flex-direction: column;
}

.align-start {
	align-items: flex-start;
}

.align-end {
	align-items: flex-end;
}

.align-center {
	align-items: center;
}

.justify-start {
	justify-content: flex-start;
}

.justify-end {
	justify-content: flex-end;
}

.justify-center {
	justify-content: center;
}

.justify-between {
	justify-content: space-between;
}

.justify-around {
	justify-content: space-around;
}
</style>
